import type { AllRouteEndpoints } from "../routeTypes";
export const engagementReportBuilder2AppGroupIdUpdateTagsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/report_builder_2/:report_id/:app_group_id",
  "/engagement/report_builder_2_reports",
];
